import "./modal.css"
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import speciality from "../../../assets/speciality.png"
import modal_hr from "../../../assets/hr.svg"
import {setAppData, setSpecialtyAccountType} from "../../../redux/register_store";
import {connect} from "react-redux";
import {useTranslation} from "react-i18next";

function IndividualModal({
                             showIndividual,
                             hideIndividualModal,
                             onSelectSpecialtyType,
                             setSpecialtyAccountType,
                             specialtyAccountType,
                             selectedSpecialtyType,
                             appData
                         }) {

    const {t} = useTranslation()

    const handleAccountChange = (newAccountType) => {
        setSpecialtyAccountType(newAccountType);
    };

    return (
        <>
            <Modal show={showIndividual} onHide={() => hideIndividualModal()}>
                <Modal.Header>
                </Modal.Header>
                <Modal.Body>
                    <div>
                        <div className="modal_individual">
                            <div className="individuals" onClick={() => onSelectSpecialtyType('special1')}>
                                <img
                                    className={`sub_img ${selectedSpecialtyType === 'special1' ? 'selected' : 'hover_sub_img'}`}
                                    src={speciality} alt=""/>
                                <p className="individuals_text">{t('modals.special_modal.corporate')}</p>
                            </div>
                            <div
                                className={appData.citizenship_status === "non_resident" ? "individuals_disable" : "individuals"}
                                onClick={() => onSelectSpecialtyType('special2')}>
                                <img
                                    className={`sub_img ${selectedSpecialtyType === 'special2' ? 'selected' : 'hover_sub_img'}`}
                                    src={speciality} alt=""/>
                                <p className="individuals_text">{t('modals.special_modal.non_profit')}</p>
                            </div>
                            <div
                                className={appData.citizenship_status === "non_resident" ? "individuals_disable" : "individuals"}
                                onClick={() => onSelectSpecialtyType('special3')}>
                                <img
                                    className={`sub_img ${selectedSpecialtyType === 'special3' ? 'selected' : 'hover_sub_img'}`}
                                    src={speciality} alt=""/>
                                <p className="individuals_text">{t('modals.special_modal.invest_club')}</p>
                            </div>
                            <div
                                className={appData.citizenship_status === "non_resident" ? "individuals_disable" : "individuals"}
                                onClick={() => onSelectSpecialtyType('special4')}>
                                <img
                                    className={`sub_img ${selectedSpecialtyType === 'special4' ? 'selected' : 'hover_sub_img'}`}
                                    src={speciality} alt=""/>
                                <p className="individuals_text">{t('modals.special_modal.limited_company')}</p>
                            </div>
                            <div
                                className={appData.citizenship_status === "non_resident" ? "individuals_disable" : "individuals"}
                                onClick={() => onSelectSpecialtyType('special5')}>
                                <img
                                    className={`sub_img ${selectedSpecialtyType === 'special5' ? 'selected' : 'hover_sub_img'}`}
                                    src={speciality} alt=""/>
                                <p className="individuals_text">{t('modals.special_modal.partnership')}</p>
                            </div>
                            <div
                                className={appData.citizenship_status === "non_resident" ? "individuals_disable" : "individuals"}
                                onClick={() => onSelectSpecialtyType('special6')}>
                                <img
                                    className={`sub_img ${selectedSpecialtyType === 'special6' ? 'selected' : 'hover_sub_img'}`}
                                    src={speciality} alt=""/>
                                <p className="individuals_text">{t('modals.special_modal.trust')}</p>
                            </div>
                            <div
                                className={appData.citizenship_status === "non_resident" ? "individuals_disable" : "individuals"}
                                onClick={() => onSelectSpecialtyType('omnibus')}>
                                <img
                                    className={`sub_img ${selectedSpecialtyType === 'omnibus' ? 'selected' : 'hover_sub_img'}`}
                                    src={speciality} alt=""/>
                                <p className="individuals_text">{t('modals.special_modal.member')}</p>
                            </div>
                        </div>

                        <img src={modal_hr} style={{width: "100%"}} alt=""/>
                        {
                            (selectedSpecialtyType === 'special1' || selectedSpecialtyType === 'special4') && (
                                <div>
                                    <div style={{display: "flex", gap: "10px"}}>
                                        <input type="radio"
                                               name="C"
                                               value="C"
                                               onChange={() => handleAccountChange('C')}
                                               checked={specialtyAccountType === "C"}
                                        />
                                        <label>{t('modals.special_modal.c_corporation')}</label>
                                    </div>

                                    <div style={{display: "flex", gap: "10px"}}>
                                        <input type="radio"
                                               name="S"
                                               value="S"
                                               onChange={() => handleAccountChange('S')}
                                               checked={specialtyAccountType === "S"}
                                        />
                                        <label>{t('modals.special_modal.s_corporation')}</label>
                                    </div>

                                    {selectedSpecialtyType === 'special4' && (
                                        <div style={{display: "flex", gap: "10px"}}>
                                            <input type="radio"
                                                   name="P"
                                                   value="P"
                                                   onChange={() => handleAccountChange('P')}
                                                   checked={specialtyAccountType === "P"}
                                            />
                                            <label>{t('modals.special_modal.partnership_corp')}</label>
                                        </div>
                                    )}
                                </div>
                            )
                        }

                        {selectedSpecialtyType === 'special6' && (
                            <div>
                                <div style={{display: "flex", gap: "10px"}}>
                                    <input type="radio"
                                           name="trust1"
                                           value="trust1"
                                           onChange={() => handleAccountChange('trust1')}
                                           checked={specialtyAccountType === "trust1"}
                                    />
                                    <label>{t('modals.special_modal.trust_ssn')}</label>
                                </div>

                                <div style={{display: "flex", gap: "10px"}}>
                                    <input type="radio"
                                           name="trust2"
                                           value="trust2"
                                           onChange={() => handleAccountChange('trust2')}
                                           checked={specialtyAccountType === "trust2"}
                                    />
                                    <label>{t('modals.special_modal.trust_id')}</label>
                                </div>
                            </div>
                        )}

                        {
                            (selectedSpecialtyType === 'special2' || selectedSpecialtyType === 'special3' || selectedSpecialtyType === 'special5') && (
                                <div></div>
                            )
                        }

                    </div>


                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => hideIndividualModal()}>
                        {t('modals.special_modal.close')}
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
}

const mapStateToProps = (state) => ({
    appData: state.appData,
    specialtyAccountType: state.appData.specialtyAccountType,
});

const mapDispatchToProps = {
    setSpecialtyAccountType,
    setAppData,
};

export default connect(mapStateToProps, mapDispatchToProps)(IndividualModal);